import { RouteConfig } from 'vue-router';
import Layout from '@/layout/index.vue'

const testRoutes: RouteConfig = {
    path: '/antManage',
    component: Layout,
    meta: {
        title: 'antManage',
        icon: 'example',
        // redirect: '/antManage/antManage',
        // alwaysShow: true 
    },
    children: [
        {
            path: 'list',
            name: 'AntManage',
            component: () => import('@/views/ant/antManage/list.vue'),
            meta: {
                title: 'antManage',
                icon: 'example',
                activeMenu: '/antManage/list',
            }
        }
    ]

}

export default testRoutes